import React from "react";

// Page numbers to render, with "…" where a run is elided.
export function pageWindow(page, pageCount) {
  if (pageCount <= 7) {
    return Array.from({ length: pageCount }, (_, i) => i + 1);
  }
  const pages = new Set([1, pageCount]);
  for (let p = page - 2; p <= page + 2; p++) {
    if (p > 1 && p < pageCount) pages.add(p);
  }
  // Near an edge the window is lopsided; top it back up so the control does
  // not visibly shrink as the user pages through.
  if (page <= 4) for (let p = 2; p <= 5; p++) pages.add(p);
  if (page >= pageCount - 3) for (let p = pageCount - 4; p < pageCount; p++) pages.add(p);

  const sorted = [...pages].sort((a, b) => a - b);
  const out = [];
  let prev = 0;
  for (const p of sorted) {
    if (prev && p - prev > 1) out.push("…");
    out.push(p);
    prev = p;
  }
  return out;
}

export default function Pagination({ page, pageCount, onPageChange }) {
  if (pageCount <= 1) return null;

  const arrow = "w-8 h-8 rounded-full border text-sm disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-50";

  return (
    <div className="flex items-center gap-1">
      <button
        type="button"
        aria-label="Previous page"
        disabled={page <= 1}
        onClick={() => onPageChange(page - 1)}
        className={arrow}
      >
        ‹
      </button>
      {pageWindow(page, pageCount).map((p, i) =>
        p === "…" ? (
          <span key={`gap-${i}`} className="px-1 text-gray-400 text-sm">
            …
          </span>
        ) : (
          <button
            key={p}
            type="button"
            onClick={() => onPageChange(p)}
            aria-current={p === page ? "page" : undefined}
            className="min-w-[28px] h-8 px-2 rounded-md text-sm"
            style={
              p === page
                ? { background: "#007E33", color: "#fff", fontWeight: 600 }
                : { color: "#4b5563" }
            }
          >
            {p}
          </button>
        )
      )}
      <button
        type="button"
        aria-label="Next page"
        disabled={page >= pageCount}
        onClick={() => onPageChange(page + 1)}
        className={arrow}
      >
        ›
      </button>
    </div>
  );
}
